import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { Groups as TopCustomersIcon, Info as InfoIcon } from '@mui/icons-material';
import { TOP_CUSTOMERS_ACCENT } from '../colorTokens';
import VitalSignsQueryLink from '../VitalSignsQueryLink';

const INFO = 'Open = New, Open and Work in Progress Salesforce cases of the top customers (the accounts set in '
  + 'Admin). Linked L2/L3/SNOW = those open cases whose external ticket is an ADO item (L2/L3) or a ServiceNow ticket. Same '
  + 'open number as the Top Customers tile.';

/** Top Customers summary box (same look as the L2 Open box): open and linked counts, then a table by code version. */
const TopCustomersOpenCard = ({ open, linked, excluded = 0, versions = [] }) => (
  <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden', height: '100%', boxSizing: 'border-box' }}>
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1, pl: 2, pr: 0.5, py: 0.5,
      background: `linear-gradient(135deg, ${TOP_CUSTOMERS_ACCENT}ee 0%, ${TOP_CUSTOMERS_ACCENT}bb 100%)`
    }}>
      <TopCustomersIcon sx={{ color: '#fff' }} />
      <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 700, letterSpacing: 0.3, flexGrow: 1 }}>
        Top Customers
      </Typography>
      <VitalSignsQueryLink tile="topCustomers" />
      <Tooltip title={INFO} arrow placement="top">
        <IconButton size="small" aria-label="About Top Customers"><InfoIcon fontSize="small" sx={{ color: '#fff' }} /></IconButton>
      </Tooltip>
    </Box>
    <Box sx={{ p: 1.75 }}>
      <Box sx={{ display: 'flex', pb: 1.25, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: TOP_CUSTOMERS_ACCENT, lineHeight: 1 }}>{open}</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>Open</Typography>
        </Box>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: TOP_CUSTOMERS_ACCENT, lineHeight: 1 }}>{linked}</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>Linked L2/L3/SNOW</Typography>
        </Box>
      </Box>
      {excluded > 0 && (
        <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1, fontWeight: 500 }}>
          Partial: {excluded} {excluded === 1 ? 'customer' : 'customers'} failed to load and {excluded === 1 ? 'is' : 'are'} not counted.
        </Typography>
      )}
      <Typography variant="caption" sx={{ display: 'block', mt: 1.25, fontWeight: 700, letterSpacing: 0.5, color: 'text.secondary' }}>
        BY CODE VERSION
      </Typography>
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden', mt: 0.5 }}>
        <Box sx={{ display: 'flex', px: 1.5, py: 0.4, bgcolor: '#f5f5f5', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="caption" sx={{ flex: 1, fontWeight: 700 }}>Version</Typography>
          <Typography variant="caption" sx={{ width: 76, textAlign: 'right', fontWeight: 700 }}>Customers</Typography>
          <Typography variant="caption" sx={{ width: 52, textAlign: 'right', fontWeight: 700 }}>Open</Typography>
        </Box>
        {versions.map((row) => (
          <Box key={row.version} sx={{ display: 'flex', px: 1.5, py: 0.4, borderBottom: '1px solid', borderColor: 'divider', '&:last-child': { borderBottom: 0 } }}>
            <Typography variant="caption" sx={{ flex: 1 }}>{row.version}</Typography>
            <Typography variant="caption" sx={{ width: 76, textAlign: 'right' }}>{row.customers}</Typography>
            <Typography variant="caption" sx={{ width: 52, textAlign: 'right', fontWeight: 700, color: TOP_CUSTOMERS_ACCENT }}>{row.open}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Paper>
);

export default TopCustomersOpenCard;
